// ** React Imports
import { createContext, useEffect, useState } from 'react'

// ** Next Import
import { useNavigate, useSearchParams } from 'react-router-dom'

// ** Axios
import axios from 'axios'

// ** Config
import authConfig from '../configs/auth'
import { ApiEndPoints } from 'src/network/endpoints'
import { axiosInstance } from 'src/network/adapter'
import FallbackSpinner from 'src/@core/components/spinner'

// ** Defaults
const defaultProvider = {
  user: null,
  loading: true,
  setUser: () => null,
  setLoading: () => Boolean,
  isInitialized: false,
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  setIsInitialized: () => Boolean,
  register: () => Promise.resolve()
}
const AuthContext = createContext(defaultProvider)

const AuthProvider = ({ children }) => {
  // ** States
  const [user, setUser] = useState(defaultProvider.user)
  const [loading, setLoading] = useState(defaultProvider.loading)
  const [isInitialized, setIsInitialized] = useState(defaultProvider.isInitialized)

  // ** Hooks
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const initAuth = async () => {
      setIsInitialized(true)
      const Token = localStorage.getItem("token")

      if (Token) {
        setLoading(true)
        await axiosInstance
          .get(ApiEndPoints.AUTH.me, {

          })
          .then(async response => {
            setLoading(false)
            setUser({ ...response.data.userData })
          })
          .catch(() => {
            localStorage.removeItem('userData')
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('accessToken')
            setUser(null)
            setLoading(false)
          })
      } else {
        setLoading(false)
      }
    }
    initAuth()
  }, [])


  const handleLogin = (params, errorCallback) => {
    axiosInstance
      .post(ApiEndPoints.AUTH.login, params)
      .then(async res => {
        window.localStorage.setItem(authConfig.storageTokenKeyName, res.data.token)
      })
      .then(() => {
        axiosInstance.get(ApiEndPoints.AUTH.me, {
          headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${localStorage.getItem(authConfig.storageTokenKeyName)}`
          }

        }).then(async response => {
          const returnUrl = searchParams.get('returnUrl')
          setUser({ ...response.data.data })
           window.localStorage.setItem('userData', JSON.stringify(response.data.data))
          const redirectURL = returnUrl && returnUrl !== '/' ? returnUrl : '/'
          if (returnUrl) {
            navigate(redirectURL)
          } else {
            navigate(redirectURL)
          }
        })
      })
      .catch(err => {
        if (errorCallback) errorCallback(err)
      })
  }


  const handleLogout = () => {
    setUser(null)
    setIsInitialized(false)
    window.localStorage.removeItem('userData')
    window.localStorage.removeItem(authConfig.storageTokenKeyName)
    navigate('/login')
  }

  const handleRegister = (params, errorCallback) => {
    axios
      .post(authConfig.registerEndpoint, params)
      .then(res => {
        if (res.data.error) {
          if (errorCallback) errorCallback(res.data.error)
        } else {
          handleLogin({ email: params.email, password: params.password })
        }
      })
      .catch(err => (errorCallback ? errorCallback(err) : null))
  }

  const values = {
    user,
    loading,
    setUser,
    setLoading,
    isInitialized,
    setIsInitialized,
    login: handleLogin,
    logout: handleLogout,
    register: handleRegister
  }

  return <AuthContext.Provider value={values}>
    {loading ? <FallbackSpinner /> : children}
  </AuthContext.Provider>
}

export { AuthContext, AuthProvider }
